import React from "react";
import { computeSection } from "../helper";

// ATIS-RECHERCHE-SITE 28/10/2026 (v2 : valeur = libellé du site) : filtre « Site » de la liste des interventions
// utilisable sans choisir de client.
// - client choisi dans le filtre « Client » : sites de ce client (comme avant) ;
// - client = « Afficher tout » : sites de tous les clients, triés, sans doublon ;
// - un site déjà filtré qui n'est plus dans la liste reste affiché (pas de filtre caché).
// Le client est lu dans les filtres de la table (et non plus dans un état mis à jour
// pendant le filtrage), ce qui marche aussi au retour sur la page (filtres mémorisés).
export const siteFilterOptions = (companies, filtered, currentValue) => {
  const options = [
    <option key="all" value="all">Afficher tout</option>
  ];
  const list = Array.isArray(companies) ? companies.filter(c => c) : [];
  let companyFilter = null;
  if (Array.isArray(filtered)) {
    companyFilter = filtered.find(f => f && f.id === "company") || null;
  }
  let source = list;
  if (companyFilter && companyFilter.value !== "all") {
    const selected = list.find(c => c.name === companyFilter.value);
    source = selected ? [selected] : [];
  }
  const seen = {};
  const items = [];
  source.forEach(company => {
    if (!company || !Array.isArray(company.sections)) {
      return;
    }
    computeSection(company).forEach(section => {
      if (!section) {
        return;
      }
      // les sites n'ont pas de « name » : l'ancienne liste prenait de fait le libellé
      // (option sans value = son texte), qui est la valeur « section » des lignes
      const value = section.name != null ? section.name : (section.label || "");
      if (!value || seen[value]) {
        return;
      }
      seen[value] = true;
      items.push({ value: value, label: section.label || section.name });
    });
  });
  if (source.length > 1) {
    items.sort((a, b) =>
      String(a.label).trim().localeCompare(String(b.label).trim(), "fr-FR")
    );
  }
  if (currentValue && currentValue !== "all" && !seen[currentValue]) {
    items.unshift({ value: currentValue, label: currentValue });
  }
  items.forEach((item, index) => {
    options.push(
      <option key={`site-opt-${index}`} value={item.value}>
        {item.label}
      </option>
    );
  });
  return options;
};



// WEBPACK FOOTER //
// ./src/components/UI/Widget/siteFilter.js